<re-alert *ngIf="alert" [type]="alert.type" (close)="alert = null">{{ alert.message }}</re-alert>
<re-alert *ngIf="showMessage" type="success" (close)="showMessage = false">
  <strong *ngIf="userAction == 'CREATED'">New user {{userFirstName}} {{userLastName}} has been created.</strong>
  <strong *ngIf="userAction == 'Deactivate'">User {{userFirstName}} {{userLastName}} has been deactivated.</strong>
  <strong *ngIf="userAction == 'Suspend'">User {{userFirstName}} {{userLastName}} has been suspended.</strong>
  <strong *ngIf="userAction == 'Delete'">User {{userFirstName}} {{userLastName}} has been deleted.</strong>
  <strong *ngIf="userAction == 'Unlock'">User {{userFirstName}} {{userLastName}} has been unlocked.</strong>
  <strong *ngIf="userAction == 'Activate'">User {{userFirstName}} {{userLastName}} has been activated.</strong>
</re-alert>

<h1>User List</h1>
<fieldset>
  <div id="search-criteria">
    <div class="row">
      <div class="col-md-3 col-xm-12">
        <div class="form-group">
          <label for="searchText">Search</label>
          <div>
            <input #searchbox type="text" id="searchText" (keypress)="searchInputKeyPress($event)"
                   class="form-control" [value]="searchText" style="margin-top:2px"
                   (input)="searchText = $event.target.value.trim()"
                   (keyup.enter)="searchUsers()">
          </div>
          <p *ngIf="allowSearchText(searchText)" class="text-danger">Asterisk (*) and backslash (\) are not searchable characters.</p>
        </div>
      </div>
      <div class="col-md-3 col-xs-12">
        <div class="form-group">
          <label for="userDropDown">Filter by status</label>
          <select2 [disabled]="loading" (onSelect)="listUsersByStatusFilter($event)" [(ngModel)]="selectedStatusFilter"
                   [settings]="{width:'100%'}"
                   name="userDropDown" id="userDropDown"
                   [options]="statusDropdownOptions"></select2>
        </div>
      </div>


    </div>

    <div class="row" *ngIf="((isLocationAdmin || isLocationLimitedAdmin) && isPhysicianFeatureEnabled) || isCorporateAdmin || isCorporateLimitedAdmin">
      <div class="col-md-3 col-xs-12" *ngIf="isLocationLimitedAdmin">
        <div class="form-group mt-1">
          <label>Filter by Location</label>
          <select2 (onSelect)="selectedLocationChanged($event)" [(ngModel)]="selectedLocation"
                   [settings]="{width:'100%'}" [required]="true"
                   name="selectedLocation"
                   [options]="locationOptions"></select2>
        </div>
      </div>
      <div class="col-md-3 col-xs-12">
        <div class="form-group mt-1">
          <label>Filter by User Type</label>
          <select2 (onSelect)="onUserTypeChanged($event)" [(ngModel)]="selectedUserType"
                   [settings]="{width:'100%'}"
                   name="userTypeDropDown" id="userTypeDropDown"
                   [options]="userTypeOptions"></select2>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12  ">
        <div class="form-group">
          <button [disabled]="loading" class="btn btn-default" type="button" (click)="clearSearch()">
            Clear all fields
          </button>
          <button [disabled]="loading || !allowSearch" class="btn btn-primary" type="button" (click)="searchUsers()">
            Search
          </button>
        </div>
      </div>
    </div>
  </div>
</fieldset>

<div class="row">
  <div class="col">
    <div class="form-group">
      <div style="vertical-align:middle">
        <button id="createNewUser" [disabled]="loading" class="btn btn-primary create-ssouser" routerLink="/user/new">
          <i class="fa fa-plus"></i> Create New User
        </button>

        <span *ngIf="errorCount>0"><a class="ml-3" [routerLink]="['/transaction-log']">View error(s)</a></span>
      </div>
    </div>
  </div>
</div>




<div class="spinner" *ngIf="loading" [re-center-in-container]>
  <div class="lspinner"></div>
</div>
<div class="mb-4">
  <table class="table table-striped table-bordered " style="width:100%;" id="userList">
  </table>
</div>

<!--<div class="spinner" *ngIf="loading">
  <div class="lspinner"></div>
</div>-->
